module.exports = __webpack_public_path__ + "static/media/video-08-tt.7ba0c178.webm";